import { render, staticRenderFns } from "./staff_selector.vue?vue&type=template&id=0777d488&scoped=true"
import script from "./staff_selector.vue?vue&type=script&lang=js"
export * from "./staff_selector.vue?vue&type=script&lang=js"
import style0 from "./staff_selector.vue?vue&type=style&index=0&id=0777d488&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0777d488",
  null
  
)

export default component.exports